"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickTournament = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var useClickTournament = function (tournament) {
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var _a = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _a.joinTournament, isSubmitting = _a.isSubmitting;
    var participate = (0, react_1.useCallback)(function (id) {
        if (id)
            joinTournament({ id: id });
    }, [joinTournament]);
    var navigateTournamentPage = (0, react_1.useCallback)(function () {
        var _a;
        if (tournament === null || tournament === void 0 ? void 0 : tournament.id)
            router.push(generateUrlWithLang("/tournaments/".concat((_a = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.slug)));
    }, [tournament, generateUrlWithLang, router]);
    var clickHandler = (0, react_1.useCallback)(function () {
        if (!!(tournament === null || tournament === void 0 ? void 0 : tournament.me))
            navigateTournamentPage();
        else
            isAuth ? participate(tournament === null || tournament === void 0 ? void 0 : tournament.id) : signUpNavigate();
    }, [tournament, isAuth, navigateTournamentPage, signUpNavigate, participate]);
    return (0, react_1.useMemo)(function () { return ({
        clickTournament: clickHandler,
        isSubmitting: isSubmitting,
    }); }, [clickHandler, isSubmitting]);
};
exports.useClickTournament = useClickTournament;
